import React, { useCallback } from 'react';
import { prop, pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { Link } from 'js/components/common/Link';
import { Icon } from 'js/components/common/Icon';
import { openSidebar } from 'js/components/main/MyAccountSidebar/store/actions';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './MyAccount.scss';

export const MyAccount: React.FC = () => {
    const dispatch = useDispatch();
    const translate = useComponentTranslations();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const userDetails = useUserSelector(prop('userDetails'));
    const { isShowSidebar, accountPage } = useAppSelector(pick(['isShowSidebar', 'accountPage']));
    const showSidebar = useCallback(() => dispatch(openSidebar()), [dispatch]);

    const content = (
        <>
            <Icon
                type={isDesktop ? 'headerMyAccount' : 'headerMobileMyAccount'}
                className={`${isDesktop ? style.icon : ''} cms-icon-my-account`}
            />
            {isDesktop && (
                <span className={style.welcome}>
                    <span className={style.welcomeMessage}>
                        {translate('welcomeTitle')}
                        <span>{','}</span>
                    </span>
                    <span>{userDetails?.loginName}</span>
                </span>
            )}
        </>
    );

    if (isShowSidebar) {
        return (
            <AccessibilityElement
                onClick={showSidebar}
                className={style.account}
                aria-label={translate('header.account.aria-label')}
            >
                {content}
            </AccessibilityElement>
        );
    }

    if (accountPage) {
        return (
            <Link
                href={accountPage}
                className={style.account}
                aria-label={translate('header.account.aria-label')}
            >
                {content}
            </Link>
        );
    }

    return null;
};
